module.exports = __webpack_public_path__ + "static/PFB__0006_App-3447857f7853c4ca7755ccb65b8d9c85.png";